module.exports = __webpack_public_path__ + "fonts/VTKSSquares.c36ef8b2.ttf";